import * as model from "@/model/prd/inventoryMgt/Adjust";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.Adjust(), newFilter)
    .withStates({ idReport: 2, baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/inventory" }) //TODO load at the application start
    .buildStore()


    